import Cookies from "js-cookie";

export const deleteCredentials = () => {
    Cookies.remove("BMX");
    Cookies.remove("BMX_ID")
}